<svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2981_57877)">
<path opacity="0.09" fill-rule="evenodd" clip-rule="evenodd" d="M100 21.1379C73.0142 21.1379 51.1379 43.0142 51.1379 70C51.1379 96.9858 73.0142 118.862 100 118.862C126.986 118.862 148.862 96.9858 148.862 70C148.862 43.0142 126.986 21.1379 100 21.1379Z" fill="currentColor"/>
<path opacity="0.55" d="M109.89 68.3042L98.0541 61.0711C97.4376 60.7012 96.6568 60.7012 96.0403 61.0711C95.4238 61.3999 95.054 62.0574 95.054 62.7561V77.2224C95.054 77.9621 95.4238 78.6197 96.0403 78.9484C96.6568 79.3183 97.4376 79.2772 98.0541 78.9073L109.89 71.6742C110.465 71.3454 110.835 70.6879 110.835 69.9892C110.835 69.3317 110.465 68.6741 109.89 68.3042Z" fill="currentColor"/>
<rect opacity="0.1" x="15" y="158.5" width="170" height="23" rx="11.5" fill="currentColor"/>
<g clip-path="url(#clip1_2981_57877)">
<g opacity="0.16">
<rect width="138" height="7" transform="translate(31 166.5)" fill="currentColor"/>
</g>
<g opacity="0.5">
<rect width="41.8929" height="7" transform="translate(31 166.5)" fill="dcurrentColor"/>
</g>
</g>
</g>
<defs>
<clipPath id="clip0_2981_57877">
<rect width="200" height="200" rx="4" fill="white"/>
</clipPath>
<clipPath id="clip1_2981_57877">
<path d="M31 170C31 168.067 32.567 166.5 34.5 166.5H165.5C167.433 166.5 169 168.067 169 170C169 171.933 167.433 173.5 165.5 173.5H34.5C32.567 173.5 31 171.933 31 170Z" fill="white"/>
</clipPath>
</defs>
</svg>
